import { Component, OnInit, ViewChild, NgZone } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SkipPopupComponent } from "../skip-popup/skip-popup.component";
import { DataCapture } from "src/app/model/data-capture";
import { IwService } from 'src/app/services/iw.service';
import { CompleteApplicationService } from 'src/app/services/complete-application.service';
import { FormControl } from '@angular/forms';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { PersonalDetailsComponent } from '../personal-details/personal-details.component';
import { ProfessionalDetailsComponent } from '../professional-details/professional-details.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { GENERIC_ERROR, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { WSCallDetailsData } from 'src/app/model/creat-update-lead';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/services/theme.service';
import { EncrDecrService } from "src/app/services/encr-decr-service.service";
declare var $: any;
declare var AmoScript: Function;
declare var _satellite: any;
declare var formEliteAdvSubmit: Function;
declare var analytics: any;

@Component({
  selector: "app-complete-application",
  templateUrl: "./complete-application.component.html",
  styleUrls: ["./complete-application.component.scss"]
})
export class CompleteApplicationComponent implements OnInit {

  dataCaptureReq: DataCapture;
  eapplyFormPostQDELabel: any;
  fcnConsent: FormControl;
  errorMessage: string;
  @ViewChild(PersonalDetailsComponent) personalDetails: PersonalDetailsComponent;
  @ViewChild(PersonalDetailsComponent) professionalDetails: ProfessionalDetailsComponent;
  @ViewChild("matExpansionPanel") expansion: MatExpansionPanel;

  step = 0;
  firstStep: any;
  expandPro: boolean;
  steps: any = 0;
  stepsAdd: any = 0;
  personalFormValid: any;
  professionalFormValid: any;
  additionalFormValid = true;
  masterData: any;
  additionalFormVisible: any;
  caSubmitSuccess: boolean = true;
  applicantName: any;
  applicantApplicationNumber: any;
  disableDcSubmit = 0;
  addCardValid: any;
  stepsAddCard: any;
  addCardFeatureCheckboxEnabled: any;

  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  fromSWIFTJourney: boolean;

  constructor(
    public dialog: MatDialog,
    private ngZone: NgZone,
    private iw: IwService,
    private completeApp: CompleteApplicationService,
    private sharedService: SharedServiceService,
    private router: Router,
    private themeService: ThemeService,
    private encryptDecService: EncrDecrService,) {
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.fromSWIFTJourney = this.sharedService.fromSwiftJourney;
    this.applicantName = this.sharedService.applicantName
    this.applicantApplicationNumber = this.sharedService.applicantApplicationNumber
    this.fcnConsent = new FormControl('');
    this.getMasterData();
    // (document.documentElement || document.body).scrollTop = 0;
    document.getElementById('sbicard') ? document.getElementById('sbicard').scrollTop = 0 : (document.documentElement || document.body).scrollTop = 0;
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    window.onunload = (e) => {
      e.preventDefault();
      this.ngZone.run(() => {
        this.SkipappDialog();
      });
    };
    if (this.sharedService.trackApplicationResponse) {
      console.log("setting qdeSubmitData from complete applicatioon component");
      this.setQdeData()
    }
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney){
        channel = this.sharedService.trackApplicationResponse.data.channelCode;
      }
      else{
        channel = this.sharedService.trackApplicationResponse.channelCode;
      }
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if (channel === 'EALB' || this.sharedService.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
      window["digitalData"].page = { pageName: 'sbi-card:banca DC:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN) {
      window["digitalData"].page = { pageName: 'sbi-card:eapply DC:campaign', pageType: 'Campaign' };
    } else if (this.sharedService.paramsshortCode || sessionStorage.getItem('sc')) {
      window["digitalData"].page = { pageName: 'sbi-card:reapply DC:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply DC:eapplyform', pageType: 'Eapply' };
    }

    if (window['digitalData']) {
      window['digitalData'].card = { cardName: this.sharedService.cardName };
      window["digitalData"].gemId1 = { GEMID1: this.sharedService.gemid1Val };
      window["digitalData"].gemId2 = { GEMID2: this.sharedService.gemid2Val };

    }
    console.log("Card NAME from shareService", this.sharedService.cardName);
    console.log("GEM Id1 value from shareService", this.sharedService.gemid1Val);
    console.log("GEM Id2 value from shareService", this.sharedService.gemid2Val);
  }

  ngAfterViewInit() {
    // this.getMasterData();
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      if(this.sharedService.fromSwiftJourney){
        channel = this.sharedService.trackApplicationResponse.data.channelCode;
      }
      else{
        channel = this.sharedService.trackApplicationResponse.channelCode;
      }

    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }

    if (channel === 'EALB' || this.sharedService.paramschannel == '901' || sessionStorage.getItem('channelId') == '901') {
      window["digitalData"].page = { pageName: 'sbi-card:banca DC:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN) {
      window["digitalData"].page = { pageName: 'sbi-card:eapply DC:campaign', pageType: 'Campaign' };
    } else if (this.sharedService.paramsshortCode || sessionStorage.getItem('sc')) {
      window["digitalData"].page = { pageName: 'sbi-card:reapply DC:reapply', pageType: 'reapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply DC:eapplyform', pageType: 'Eapply' };
    }
  }

  SkipappDialog(): void {
    const dialogRef = this.dialog.open(SkipPopupComponent, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed");
    });
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  onSubmit() {
    if (this.disableDcSubmit) {
      return;
    }
    if (!this.personalFormValid || !this.professionalFormValid || this.addCardFeatureCheckboxEnabled || (!this.additionalFormValid && this.additionalFormVisible)) {
      // this.fcnConsent.invalid || ;
      return;
    } else {
      this.dataCaptureReq = new DataCapture();
      let fname: any;
      let lname: any;
      if (this.sharedService.trackApplicationResponse) {
        if (this.fromSWIFTJourney) {
          fname = (this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.firstName) ? this.sharedService.trackApplicationResponse.data.applicantDetails.firstName : '';
          lname = (this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.lastName) ? this.sharedService.trackApplicationResponse.data.applicantDetails.lastName : '';
          this.dataCaptureReq.embossingName = this.sharedService.trackApplicationResponse.data.personalDetails && this.sharedService.trackApplicationResponse.data.personalDetails.embossingName ? this.sharedService.trackApplicationResponse.data.personalDetails.embossingName : '';

        }
        else {
          fname = (this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName) ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName : '';
          lname = (this.sharedService.trackApplicationResponse.eapplyApplicantDetails && this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName) ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName : '';
          this.dataCaptureReq.embossingName = fname + ' ' + lname;
        }

      } else {
        fname = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserFirstName ? this.sharedService.qdeSubmitData.WSCallUserFirstName : '';
        lname = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallUserLastName ? this.sharedService.qdeSubmitData.WSCallUserLastName : '';
        this.dataCaptureReq.embossingName = fname + ' ' + lname;
      }

      this.dataCaptureReq.resiStatus = this.completeApp.personalData && this.completeApp.personalData.resiStatus ? this.completeApp.personalData.resiStatus : null;
      this.dataCaptureReq.yearsAtCurrentResi = this.completeApp.personalData && this.completeApp.personalData.yearsAtCurrentResi ? this.completeApp.personalData.yearsAtCurrentResi : null;
      this.dataCaptureReq.fathersName = this.completeApp.personalData && this.completeApp.personalData.fathersName ? this.completeApp.personalData.fathersName : null;
      this.dataCaptureReq.mothersName = this.completeApp.personalData && this.completeApp.personalData.mothersName ? this.completeApp.personalData.mothersName : null;
      this.dataCaptureReq.preferredMailAddress = this.completeApp.personalData && this.completeApp.personalData.preferredMailAddress ? this.completeApp.personalData.preferredMailAddress : null;
      this.dataCaptureReq.userId = 'Y';
      this.dataCaptureReq.permPinCode = this.completeApp.personalData && this.completeApp.personalData.permPinCode ? this.completeApp.personalData.permPinCode : null;
      this.dataCaptureReq.permState = this.sharedService && this.sharedService.perState ? this.sharedService.perState : null;
      this.dataCaptureReq.qualification = this.completeApp.personalData && this.completeApp.personalData.qualification ? this.completeApp.personalData.qualification : null;
      this.dataCaptureReq.alternateCardNumber = this.completeApp.personalData && this.completeApp.personalData.alternateCardNumber ? this.completeApp.personalData.alternateCardNumber : null;
      this.dataCaptureReq.existingRelwithSBI = this.completeApp.personalData && this.completeApp.personalData.existingRelwithSBI ? this.completeApp.personalData.existingRelwithSBI : null;
      this.dataCaptureReq.sbiAccountNo = this.completeApp.personalData && this.completeApp.personalData.sbiAccountNo ? this.completeApp.personalData.sbiAccountNo : null;
      this.dataCaptureReq.isPermResiAddressSame = this.completeApp.personalData && this.completeApp.personalData.isPermResiAddressSame ? this.completeApp.personalData.isPermResiAddressSame : null;
      this.dataCaptureReq.perHouseNo = this.completeApp.personalData && this.completeApp.personalData.perHouseNo ? this.completeApp.personalData.perHouseNo : null;
      this.dataCaptureReq.perLocality = this.completeApp.personalData && this.completeApp.personalData.perLocality ? this.completeApp.personalData.perLocality : null;
      this.dataCaptureReq.perAddLine = this.completeApp.personalData && this.completeApp.personalData.perAddLine ? this.completeApp.personalData.perAddLine : null;
      this.dataCaptureReq.officialEmailId = this.completeApp.professionalData && this.completeApp.professionalData.officialEmailId ? this.completeApp.professionalData.officialEmailId : null;
      this.dataCaptureReq.offPhone = this.completeApp.professionalData && this.completeApp.professionalData.offPhone ? this.completeApp.professionalData.offPhone : null;
      this.dataCaptureReq.businessType = this.completeApp.professionalData && this.completeApp.professionalData.businessType ? this.completeApp.professionalData.businessType : null;
      this.dataCaptureReq.offAddLine1 = this.completeApp.professionalData && this.completeApp.professionalData.offAddLine1 ? this.completeApp.professionalData.offAddLine1 : null;
      this.dataCaptureReq.offAddLine2 = this.completeApp.professionalData && this.completeApp.professionalData.offAddLine2 ? this.completeApp.professionalData.offAddLine2 : null;
      this.dataCaptureReq.offLandmark = this.completeApp.professionalData && this.completeApp.professionalData.offLandmark ? this.completeApp.professionalData.offLandmark : null;
      this.dataCaptureReq.offPincode = this.completeApp.professionalData && this.completeApp.professionalData.offPincode ? this.completeApp.professionalData.offPincode : null;
      this.dataCaptureReq.annualIncome = this.completeApp.professionalData && this.completeApp.professionalData.annualIncome ? this.completeApp.professionalData.annualIncome : null;
      this.dataCaptureReq.amaId = this.completeApp.additionalData && this.completeApp.additionalData.amaId ? this.completeApp.additionalData.amaId : null;
      this.dataCaptureReq.frequentFlyer = this.completeApp.additionalData && this.completeApp.additionalData.frequentFlyer ? this.completeApp.additionalData.frequentFlyer : null;
      this.dataCaptureReq.perCity = this.completeApp.personalData && this.completeApp.personalData.perCity ? this.completeApp.personalData.perCity : null;
      this.dataCaptureReq.ckycNumber = this.completeApp.additionalData && this.completeApp.additionalData.ckycNumber ? this.completeApp.additionalData.ckycNumber : null;
      this.dataCaptureReq.cppConsent = this.fcnConsent ? this.fcnConsent.value : null;
      if (this.fromSWIFTJourney) {
        this.dataCaptureReq.personalEmailId = this.sharedService.trackApplicationResponse.data && this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId : null;
        this.dataCaptureReq.feeCode = this.sharedService.feeCodeForDataCapture ? this.sharedService.feeCodeForDataCapture : (this.sharedService.trackApplicationResponse.data && this.sharedService.trackApplicationResponse.data.productDetail && this.sharedService.trackApplicationResponse.data.productDetail.feeCode ? this.sharedService.trackApplicationResponse.data.productDetail.feeCode : null);
        this.dataCaptureReq.applicationNumber = this.sharedService.trackApplicationResponse.data ? this.sharedService.trackApplicationResponse.data.applicationNumber : (this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.applicationNumber ? this.sharedService.qdeSuccessResponse.applicationNumber : null);
        this.dataCaptureReq.offCity =
          (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.data.officeAddress && this.sharedService.trackApplicationResponse.data.officeAddress.offCity)
            ? this.sharedService.trackApplicationResponse.data.officeAddress.offCity : ((this.completeApp.professionalData && this.completeApp.professionalData.offCity) ? this.completeApp.professionalData.offCity : null);

        this.dataCaptureReq.resiStdCode = null;
        this.dataCaptureReq.offStdCode = (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.data.officeAddress && this.sharedService.trackApplicationResponse.data.officeAddress.offStdCode)
          ? this.sharedService.trackApplicationResponse.data.officeAddress.offStdCode : (this.sharedService.offStdCode ? this.sharedService.offStdCode : null);
      }
      else {
        this.dataCaptureReq.feeCode = this.sharedService.feeCodeForDataCapture ? this.sharedService.feeCodeForDataCapture : (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.productDetail ? this.sharedService.trackApplicationResponse.productDetail.feeCode : null);
        this.dataCaptureReq.applicationNumber = this.sharedService.trackApplicationResponse ? this.sharedService.trackApplicationResponse.applicationNumber : (this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.applicationNumber ? this.sharedService.qdeSuccessResponse.applicationNumber : null);
        this.dataCaptureReq.offCity =
          (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.officeAddress && this.sharedService.trackApplicationResponse.officeAddress.offCity)
            ? this.sharedService.trackApplicationResponse.officeAddress.offCity : ((this.completeApp.professionalData && this.completeApp.professionalData.offCity) ? this.completeApp.professionalData.offCity : null);

        this.dataCaptureReq.resiStdCode = (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.eapplyContactDetails && this.sharedService.trackApplicationResponse.eapplyContactDetails.resiStdCode)
          ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiStdCode : (this.sharedService.resiStdCode ? this.sharedService.resiStdCode : null);
        this.dataCaptureReq.offStdCode = (this.sharedService.trackApplicationResponse && this.sharedService.trackApplicationResponse.officeAddress && this.sharedService.trackApplicationResponse.officeAddress.offStdCode)
          ? this.sharedService.trackApplicationResponse.officeAddress.offStdCode : (this.sharedService.offStdCode ? this.sharedService.offStdCode : null);
      }


      this.dataCaptureReq.isInternationalUsageDisabled = '0';
       this.dataCaptureReq.AppSeqId = this.sharedService.dcSeqId;
      this.dataCaptureReq.contactlessDomestic='';
      this.dataCaptureReq.contactlessInternational='';
      this.dataCaptureReq.domesticOnline='';
      this.dataCaptureReq.posInternational='';
      this.dataCaptureReq.consentGiven= 'N';

      // this.dataCaptureReq.AppSeqId = this.sharedService.dcSeqId;
      // this.dataCaptureReq.contactlessDomestic = this.completeApp.addCardFeatureData && this.completeApp.addCardFeatureData.contactlessDomestic ? this.completeApp.addCardFeatureData.contactlessDomestic : 'N';
      // this.dataCaptureReq.contactlessInternational = this.completeApp.addCardFeatureData && this.completeApp.addCardFeatureData.contactlessInternational ? this.completeApp.addCardFeatureData.contactlessInternational : 'N';
      // this.dataCaptureReq.domesticOnline = this.completeApp.addCardFeatureData && this.completeApp.addCardFeatureData.domesticOnline ? this.completeApp.addCardFeatureData.domesticOnline : 'N';
      // this.dataCaptureReq.internationalOnline = this.completeApp.addCardFeatureData && this.completeApp.addCardFeatureData.internationalOnline ? this.completeApp.addCardFeatureData.contactlessDomestic : 'N';
      // this.dataCaptureReq.posInternational = this.completeApp.addCardFeatureData && this.completeApp.addCardFeatureData.posInternational ? this.completeApp.addCardFeatureData.posInternational : 'N';
      // this.dataCaptureReq.consentGiven = this.completeApp.addCardFeatureData && this.completeApp.addCardFeatureData.consentGiven ? this.completeApp.addCardFeatureData.consentGiven : 'Y';
      let reqObj = Object.assign({}, this.sharedService.qdeSubmitData, this.sharedService.cApersonalData, this.sharedService.cAprofessisonalData, this.sharedService.cAadditionalCardFeatureData, this.sharedService.cAadditionalData);
      console.log('res from complete application componnent before', reqObj);
      reqObj = this.trimObject(reqObj);
      console.log('res from complete application componnent', reqObj, this.dataCaptureReq);


      this.completeApp.saveUpdateApplication(reqObj).subscribe((result: any) => {
        if (result) {
          if (result.DataCaptureRes && result.DataCaptureRes.WSCallStatus && result.DataCaptureRes.WSCallStatus.toLowerCase() === 'success') {
            this.caSubmitSuccess = true;
            this.dataCaptureReq = this.trimObject(this.dataCaptureReq);
            this.completeApp.submitCompleteApp(this.dataCaptureReq).subscribe((response: any) => {
              const completeAppResult = { ...response.body };
              if (completeAppResult && completeAppResult.status && completeAppResult.status.toLowerCase() === "success") {
                this.disableDcSubmit = 1;
                let accessToken: any;
                let expiryTime: any;
                if (IS_CAMPAIGN) {
                  window["page"] = 'ev_dcsubmit';
                  window["transactionId"] = this.sharedService.amoSequeceNumber ? this.sharedService.amoSequeceNumber : '';
                  AmoScript();
                }
                this.callLaunchSubmit();
                if (response.headers && response.headers.get("access_token")) {
                  accessToken = response.headers.get("access_token");
                }
                if (response.headers && response.headers.get("expiry_time")) {
                  expiryTime = response.headers.get("expiry_time");
                }
                if (accessToken) {
                  sessionStorage.setItem("s24_access_token", accessToken);
                }
                if (expiryTime) {
                  sessionStorage.setItem("s24_expiry_time", expiryTime);
                }
                this.errorMessage = '';
                this.sharedService.appCompleted = true;
                this.completeApp.submitClickedComp = true;
                const dialogRef = this.dialog.open(SkipPopupComponent, { disableClose: true });
                dialogRef.afterClosed().subscribe(result => {
                  console.log("The dialog was closed");
                });

              } else if (completeAppResult && completeAppResult.status && completeAppResult.status.toLowerCase() === "failure") {
                // this.errorMessage = GENERIC_ERROR;
                // this.disableDcSubmit = 0;
                if (completeAppResult && completeAppResult.errorCode && completeAppResult.errorCode == "100") {
                  this.errorMessage = completeAppResult.errorMessage;
                } else {
                  this.errorMessage = GENERIC_ERROR;
                  this.disableDcSubmit = 0;
                }
              } else {
                this.disableDcSubmit = 0;
                this.errorMessage = GENERIC_ERROR;
              }
            }, err => {
              this.disableDcSubmit = 0;
              this.errorMessage = GENERIC_ERROR;
            });
          } else {
            this.caSubmitSuccess = false;
            this.errorMessage = GENERIC_ERROR;
            window["digitalData"].error = { message: GENERIC_ERROR };
            if (window['_satellite']) {
              _satellite.track('form_error');
            }
          }
        } else {
          this.caSubmitSuccess = false;
          this.errorMessage = GENERIC_ERROR;
        }
      }, (error) => {
        this.caSubmitSuccess = false;
        this.errorMessage = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if (window['_satellite']) {
          _satellite.track('form_error');
        }
      });
    }
    // if (window['analytics']) {
    //   console.log('Value of Card Type', this.sharedService.qdeSubmitData.WSCallCardType);
    //   analytics.track('eapply__click__final_submit_button', {

    //     'MODE_OF_CONVERSION': '',
    //     'IS_ORGANIC': 'N',
    //     'SOURCE_GEM_ID1': this.sharedService.paramsgemid1,
    //     'SOURCE_GEM_ID2': this.sharedService.paramsgemid2,
    //     'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
    //     'CHANNEL_NAME': this.sharedService.paramschannel,
    //     'JOURNEY_NAME': 'EAPPLY',
    //     'FIRST_NAME': this.sharedService.qdeSubmitData.WSCallUserFirstName,
    //     'LAST_NAME': this.sharedService.qdeSubmitData.WSCallUserLastName,
    //     'MIDDLE_NAME': this.sharedService.qdeSubmitData.WSCallUserMiddleName,
    //     'EMAIL': this.sharedService.qdeSubmitData.WSCallUserEmailId,
    //     'Mobile_no': this.sharedService.qdeSubmitData.WSCallUserMobileNumber,
    //     'CITY': this.sharedService.qdeSubmitData.WSCallUserCity,
    //     'COMPANY_NAME': this.sharedService.qdeSubmitData.WSCallUserCompany,
    //     'DOB': this.sharedService.qdeSubmitData.WSCallUserDOB,
    //     'DESIGNATION': this.sharedService.qdeSubmitData.WSCallUserDesignation,
    //     'ANNUAL_SALARY': this.sharedService.qdeSubmitData.WSCallUserAnnualIncomeValue,
    //     'OFFICE_PINCODE': this.sharedService.qdeSubmitData.WSCallUserOfficePincode,
    //     'pan': this.sharedService.qdeSubmitData.WSCallUserPanNumber,
    //     'RESI_ADDRESS': this.sharedService.qdeSubmitData.WSCallUserAddressLine,
    //     'RESI_PINCODE': this.sharedService.qdeSubmitData.WSCallUserResiPincode,
    //     'OCCUPATION_TYPE': this.sharedService.qdeSubmitData.WSCallUserOccupationCode,
    //     'CARD_TYPE': this.sharedService.qdeSubmitData.WSCallCardType,
    //   });
    // }
  }

  getMasterData() {
    let requestBody: any;
    let channel: any;
    if (this.sharedService.trackApplicationResponse) {
      channel = this.sharedService.trackApplicationResponse.channelCode;
    } else {
      channel = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }
    if(this.fromSWIFTJourney){
      channel = this.sharedService.trackApplicationResponse.data.channelCode;
      console.log("new requestBody from complete application component");
      requestBody = {
        data: {
          cardType: this.sharedService.trackApplicationResponse.data && this.sharedService.trackApplicationResponse.data.cardType ? this.sharedService.trackApplicationResponse.data.cardType : null,
          cardChannelCode: channel,
          cityList: (channel === 'EALB') ? 'N' : 'Y',
          companyList: "N",
          bancaCityList: (channel === 'EALB') ? 'Y' : 'N',
          designationList: "N",
          bankNameList: "N",
          branchNameList: null
        },
        action: "submit",
        type: "Swift App"
      };
      console.log("neww request Body from getmaster data", requestBody);
    }
    else {
      requestBody = {
        cardType: this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallCardType ? this.sharedService.qdeSubmitData.WSCallCardType : null,
        cardChannelCode: channel,
        cityList: (channel === 'EALB') ? 'N' : 'Y',
        bancaCityList: (channel === 'EALB') ? 'Y' : 'N',
        companyList: 'N'
      };
      console.log("old request Body from getmaster data", requestBody);
    }
    
    
    this.completeApp.fetchMatserData(requestBody).subscribe((result: any) => {
      if(this.fromSWIFTJourney){
        result = this.encryptDecService.get(result);
        if (result && result.statusCode === "000") {
          console.log("new master data call from coplete application component", result);
          this.masterData = result.data.eapplyMasterDataRsType;
        } else {
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
        }
      }
      else {
        
        if (result.eapplyMasterDataRsType && result.eapplyMasterDataRsType.statusCode === "000") {
          console.log("old master data call from coplete application component", result);
          this.masterData = result.eapplyMasterDataRsType;
        } else {
          window["digitalData"].error = { message: GENERIC_ERROR };
          if (window['_satellite']) {
            _satellite.track('form_error');
          }
        }
      }
      
    }, err => {
      console.log('Service Error', err);
    });
  }

  expandProfessional(event) {
    this.expandPro = event.expanded;
    this.steps = event.steps;

    this.personalFormValid = event.pValid;
  }

  perFormValid(event) {
    this.personalFormValid = event.pValid;
  }

  proFormValid(event) {
    this.professionalFormValid = event.proValid;
    // this.expandAdditional = event.expanded;
    this.stepsAddCard = event.expanded;
    this.stepsAdd = event.steps;
  }

  addFormValid(event) {
    // this.additionalFormValid = event.addValid;
    this.additionalFormVisible = event.additionalSectionVisible;
    if (this.additionalFormVisible) {
      this.additionalFormValid = event.addValid;
    }
    else {
      this.additionalFormValid = true;
    }
  }

  expandAdditional(event) {
    this.expandAdditional = event.expanded;
    this.stepsAdd = event.steps;
  }
  addCardFeatureFormValid(event) {
    this.expandAdditional = event.expanded;
    // this.addCardValid = event.addCardFeatureValid;
    this.stepsAdd = 1;
    this.addCardFeatureCheckboxEnabled = event.addCardFeatureCheckboxEnabled;

  }

  setQdeData() {

    let qdeData = new WSCallDetailsData();
    if (this.fromSWIFTJourney) {
      qdeData.WSCallUserFirstName = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.firstName ? this.sharedService.trackApplicationResponse.data.applicantDetails.firstName : null;
      // qdeData.WSCallUserMiddleName = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.middleName ? this.sharedService.trackApplicationResponse.data.applicantDetails.middleName : null;
      qdeData.WSCallUserMiddleName = "";
      qdeData.WSCallUserLastName = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.lastName ? this.sharedService.trackApplicationResponse.data.applicantDetails.lastName : null;
      qdeData.WSCallUserGender = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.gender ? this.sharedService.trackApplicationResponse.data.applicantDetails.gender : null;
      qdeData.WSCallUserCity = this.sharedService.trackApplicationResponse.data.contactDetails && this.sharedService.trackApplicationResponse.data.contactDetails.resiCity ? this.sharedService.trackApplicationResponse.data.contactDetails.resiCity : null;
      qdeData.WSCallUserOccupationCode = "";
      qdeData.WSCallUserDOB = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth ? ('' + new Date(this.sharedService.trackApplicationResponse.data.applicantDetails.dateOfBirth)) : null;
      qdeData.WSCallUserPanNumber = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.pan ? this.sharedService.trackApplicationResponse.data.applicantDetails.pan : null;
      qdeData.WSCallUserEmailId = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId ? this.sharedService.trackApplicationResponse.data.applicantDetails.personalEmailId : null;
      qdeData.WSCallUserMobileNumber = this.sharedService.trackApplicationResponse.data.applicantDetails && this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber ? this.sharedService.trackApplicationResponse.data.applicantDetails.mobileNumber : null;
      qdeData.WSCallCardType = this.sharedService.sbic_card_Type ? this.sharedService.sbic_card_Type : (this.sharedService.trackApplicationResponse.data.cardType ? this.sharedService.trackApplicationResponse.data.cardType : null);
      qdeData.WSCallUserDesignation = this.sharedService.trackApplicationResponse.data.employmentDetails && this.sharedService.trackApplicationResponse.data.employmentDetails.designation ? this.sharedService.trackApplicationResponse.data.employmentDetails.designation : null;
      qdeData.WSCallUserCompany = this.sharedService.trackApplicationResponse.data.employmentDetails && this.sharedService.trackApplicationResponse.data.employmentDetails.companyName ? this.sharedService.trackApplicationResponse.data.employmentDetails.companyName : null;
      qdeData.WSCallUserOfficePincode = this.sharedService.trackApplicationResponse.data.officeAddress && this.sharedService.trackApplicationResponse.data.officeAddress.offPinCode ? this.sharedService.trackApplicationResponse.data.officeAddress.offPinCode : null;
      qdeData.WSCallUserHouseNo = this.sharedService.trackApplicationResponse.data.contactDetails && this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine1 ? this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine1 : null;
      qdeData.WSCallUserLocality = this.sharedService.trackApplicationResponse.data.contactDetails && this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine3 ? this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine3 : null;
      qdeData.WSCallUserAddressLine = this.sharedService.trackApplicationResponse.data.contactDetails && this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine2 ? this.sharedService.trackApplicationResponse.data.contactDetails.resiAddressLine2 : null;
      qdeData.WSCallUserResiPincode = this.sharedService.trackApplicationResponse.data.contactDetails && this.sharedService.trackApplicationResponse.data.contactDetails.resiPinCode ? this.sharedService.trackApplicationResponse.data.contactDetails.resiPinCode : null;
      // qdeData.WSCallUserHouseNo = "";
      // qdeData.WSCallUserLocality = "";
      // qdeData.WSCallUserAddressLine = "";
      // qdeData.WSCallUserResiPincode = "";
      // qdeData.WSCallUserNationality = "IND";
      
      let nationality_local = this.sharedService.trackApplicationResponse.data.personalDetails && this.sharedService.trackApplicationResponse.data.personalDetails.nationality ? this.sharedService.trackApplicationResponse.data.personalDetails.nationality : null;
      if (nationality_local === "INDIAN" || nationality_local === "IND") {
        qdeData.WSCallUserNationality = "IND";
      }
      else {
        qdeData.WSCallUserNationality = "OTH";
      }
      qdeData.WSCallSourceCode = this.sharedService.trackApplicationResponse.data.sourceCode ? this.sharedService.trackApplicationResponse.data.sourceCode : null;
      qdeData.WSCallChannelCode = this.sharedService.trackApplicationResponse.data.channelCode ? this.sharedService.trackApplicationResponse.data.channelCode : null;
    }
    else {
      qdeData.WSCallUserFirstName = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName : null;
      qdeData.WSCallUserMiddleName = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.middleName : null;
      qdeData.WSCallUserLastName = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.lastName : null;
      qdeData.WSCallUserGender = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.gender : null;
      qdeData.WSCallUserCity = this.sharedService.trackApplicationResponse.eapplyContactDetails ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiCity : null;
      qdeData.WSCallUserOccupationCode = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.education : null;
      qdeData.WSCallUserDOB = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? ('' + new Date(this.sharedService.trackApplicationResponse.eapplyApplicantDetails.dateOfBirth)) : null;
      qdeData.WSCallUserPanNumber = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.pan : null;
      qdeData.WSCallUserEmailId = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.personalEmailId : null;
      qdeData.WSCallUserMobileNumber = this.sharedService.trackApplicationResponse.eapplyApplicantDetails ? this.sharedService.trackApplicationResponse.eapplyApplicantDetails.mobileNumber : null;
      qdeData.WSCallCardType = this.sharedService.sbic_card_Type ? this.sharedService.sbic_card_Type : (this.sharedService.trackApplicationResponse.cardType ? this.sharedService.trackApplicationResponse.cardType : null);
      qdeData.WSCallUserDesignation = this.sharedService.trackApplicationResponse.eapplyEmploymentDetails ? this.sharedService.trackApplicationResponse.eapplyEmploymentDetails.designation : null;
      qdeData.WSCallUserCompany = this.sharedService.trackApplicationResponse.eapplyEmploymentDetails ? this.sharedService.trackApplicationResponse.eapplyEmploymentDetails.companyName : null;
      qdeData.WSCallUserOfficePincode = this.sharedService.trackApplicationResponse.officeAddress ? this.sharedService.trackApplicationResponse.officeAddress.offPinCode : null;
      qdeData.WSCallUserHouseNo = this.sharedService.trackApplicationResponse.eapplyContactDetails ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress1 : null;
      qdeData.WSCallUserLocality = this.sharedService.trackApplicationResponse.eapplyContactDetails ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress3 : null;
      qdeData.WSCallUserAddressLine = this.sharedService.trackApplicationResponse.eapplyContactDetails ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiAddress2 : null;
      qdeData.WSCallUserResiPincode = this.sharedService.trackApplicationResponse.eapplyContactDetails ? this.sharedService.trackApplicationResponse.eapplyContactDetails.resiPin : null;
      qdeData.WSCallUserNationality = this.sharedService.trackApplicationResponse.eapplyPersonalDetails ? this.sharedService.trackApplicationResponse.eapplyPersonalDetails.nationality : null;
      qdeData.WSCallSourceCode = this.sharedService.trackApplicationResponse.sourceCode ? this.sharedService.trackApplicationResponse.sourceCode : null;
      qdeData.WSCallChannelCode = this.sharedService.trackApplicationResponse.channelCode ? this.sharedService.trackApplicationResponse.channelCode : null;
    }

    this.sharedService.qdeSubmitData = qdeData;
    console.log("qdeSubmitData from complete application component", this.sharedService.qdeSubmitData);
  }

  callLaunchSubmit() {
    let labelsDisplay: any
    if (this.eapplyFormPostQDELabel) {
      if (this.eapplyFormPostQDELabel.employmentSection_details && this.eapplyFormPostQDELabel.employmentSection_details.officephoneNo_label) {
        labelsDisplay = this.eapplyFormPostQDELabel.employmentSection_details.officephoneNo_label
      } if (this.eapplyFormPostQDELabel.officeAddressSection_details && this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine1_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine1_label
      } if (this.eapplyFormPostQDELabel.officeAddressSection_details && this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine2_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine2_label
      } if (this.eapplyFormPostQDELabel.officeAddressSection_details && this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine3_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.officeAddressSection_details.addressLine3_label
      } if (this.eapplyFormPostQDELabel.residentailSection_details && this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.residentailSection_details.pinCode_label
      } if (this.eapplyFormPostQDELabel.amaId && this.eapplyFormPostQDELabel.amaId.ama_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.amaId.ama_label;
      } if (this.eapplyFormPostQDELabel.frequentFlyer && this.eapplyFormPostQDELabel.frequentFlyer.ff_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.frequentFlyer.ff_label;
      } if (this.eapplyFormPostQDELabel.ckycNumber_text && this.eapplyFormPostQDELabel.ckycNumber_text.ckycNumber_label) {
        labelsDisplay = labelsDisplay + "|" + this.eapplyFormPostQDELabel.ckycNumber_text.ckycNumber_label;
      }
    }
    formEliteAdvSubmit(this.sharedService.cardName, 'Professional|Additional Details', labelsDisplay)
  }
}
